import React, { useEffect } from 'react';
// import Table from '../components/Table/Table';
// import { toJS } from '../utils/immutableUtils';
import { useSelector, useDispatch } from 'react-redux';
import View from './views';
// import PaperContainer from '../components/common/PaperContainer';
import { getMarketName } from '../features/app/selectors';
import { totalRangePpsi } from 'features/PpsiContainer/actions';
import { makeStyles } from '@material-ui/core/styles';
import {
  getTotalRangeReport,
  getIsFetchingRangeReport,
  getRangeReportError
} from 'features/PpsiContainer/selectors';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import ProgressFullscreen from '../components/common/ProgressFullscreen';
import { toJS } from 'utils/immutableUtils';
// import ReportsListView from './ReportsListView';
import StartPage from './StartPage';
import { Chart as ChartJS, ArcElement, Tooltip } from 'chart.js';
import { Pie } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, ChartDataLabels);

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4),
    height: 'calc(100% - 64px)'
  },
  header: {
    backgroundColor: '#fafafa',
    height: 64,
    paddingTop: 16,
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
  },
  headerText: {
    paddingLeft: 16,
    fontSize: '1.25rem',
    fontFamily: 'Roboto',
    fontWeight: 500,
    lineHeight: '1.6'
  },
  paper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 15,
    backgroundColor: '#fff',
    paddingBottom: 15,
    borderRadius: 4,
    boxShadow:
      '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)'
  }
}));

const TotalRangeDishStatisticsView = () => {
  const currOrganization = useSelector(getMarketName);
  const totalRangeReport = useSelector(getTotalRangeReport);
  const rangeReportError = useSelector(getRangeReportError);
  const isFetchingRangeReport = useSelector(getIsFetchingRangeReport);
  const rangeReport = toJS(totalRangeReport, []);
  const classes = useStyles();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(totalRangePpsi(currOrganization));
  }, [dispatch]);

  if (isFetchingRangeReport) {
    return <ProgressFullscreen open />;
  }

  if (rangeReportError) {
    return <StartPage />;
  }

  const chartDatas = [];

  rangeReport &&
    rangeReport.length > 0 &&
    rangeReport.forEach(i => {
      if (i.status === 'NEW LOCAL' || i.status === 'NEW') {
        chartDatas.push({ ...i, color: '#e3e171' });
      } else if (i.status === 'NEW GLOBAL') {
        chartDatas.push({ ...i, color: '#cbcdcb' });
      } else if (i.status === 'DRAFT') {
        chartDatas.push({ ...i, color: '#66b6d2' });
      } else if (i.status === 'GLOBAL REVIEW') {
        chartDatas.push({ ...i, color: '#576ae3' });
      } else if (i.status === 'GLOBAL REJECTED') {
        chartDatas.push({ ...i, color: '#e371bb' });
      } else if (i.status === 'GLOBAL APPROVED') {
        chartDatas.push({ ...i, color: '#b957e3' });
      } else if (i.status === 'SCHEDULED') {
        chartDatas.push({ ...i, color: '#321b3c' });
      } else if (i.status === 'PUBLISHED') {
        chartDatas.push({ ...i, color: '#5de357' });
      } else if (i.status === 'UNPUBLISHED') {
        chartDatas.push({ ...i, color: '#f70a16' });
      } else if (i.status === 'EXCLUDED') {
        chartDatas.push({ ...i, color: '#bba344' });
      } else if (i.status === 'UNTRACKABLE') {
        chartDatas.push({ ...i, color: '#75a4ba' });
      }
    });

  const colors = chartDatas && chartDatas.map(i => i.color);
  const labels = chartDatas && chartDatas.map(i => i.status);
  const value = chartDatas && chartDatas.map(i => i.count);
  const totalValue = value.reduce((a, b) => a + b, 0);

  const data = {
    labels,
    datasets: [
      {
        label: 'My First dataset',
        data: value,
        spacing: 0.4,
        backgroundColor: colors
      }
    ]
  };

  // ChartJS.defaults.plugins.tooltip.enabled = false;

  const options = {
    responsive: true,
    plugins: {
      tooltip: {
        enabled: true
      },
      legend: {
        display: false // Hides the legend
      },
      datalabels: {
        display: true,
        color: '#000',
        // render: 'percentage',
        font: { size: 14, weight: 'bold' },
        anchor: 'center',
        offset: 45,
        align: 'end',
        formatter: value => {
          const sum = totalValue;

          if (!value || !sum || isNaN(value) || isNaN(sum) || sum === 0) {
            return '0%';
          }

          const percentage = Math.floor((value * 100) / sum) + '%';
          return percentage;
        }
      }
    }
  };

  View.PpsiTotalRangeDish.visit();

  return (
    <div className={classes.container}>
      <div>
        <div className={classes.header}>
          <span className={classes.headerText}>
            Total Range Dish Statistics
          </span>
        </div>
        <div className={classes.paper}>
          <div style={{ width: '30%', height: '30%' }}>
            <span>Count of PRF No.</span>
            <Pie data={data} options={options} />
          </div>
          <div style={{ marginLeft: '20px' }}>
            <table>
              <thead>
                <tr key={Math.random()}>
                  <th> </th>
                  <th> </th>
                  <th> </th>
                </tr>
              </thead>
              {chartDatas.map((val, key) => {
                return (
                  <tbody key={Math.random()}>
                    <tr key={key} style={{ padding: '30px !important' }}>
                      <td>
                        <div
                          style={{
                            backgroundColor: val.color,
                            width: '20px',
                            height: '10px'
                          }}
                        />
                      </td>
                      <td>{val.status}</td>
                      <td style={{ paddingLeft: '30px' }}>
                        {val.count != null && totalValue > 0
                          ? `${val.count} (${(
                              (val.count / totalValue) *
                              100
                            ).toFixed(1)}%)`
                          : `${val.count || 0} (0%)`}
                      </td>
                    </tr>
                  </tbody>
                );
              })}
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TotalRangeDishStatisticsView;
